import React from "react";
import "@reach/menu-button/styles.css";
import styles from "./AccountSelector.module.less";
import AccountDetails from "../AccountDetails/AccountDetails";
import { Menu, MenuList, MenuButton, MenuItem } from "@reach/menu-button";
const AccountSelector = (props) => (<Menu>
		<MenuButton className={styles.toggle}>
			{props.children}
		</MenuButton>
		<MenuList className={styles.menu}>
			{props.accounts.map(account => (<MenuItem key={account.id} onSelect={() => props.onSelect(account)}>
					<AccountDetails account={account}/>
				</MenuItem>))}
		</MenuList>
	</Menu>);
export default AccountSelector;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/secure/PayNowForm/PaymentInfoFields/AccountSelector/AccountSelector.tsx